import React from "react"
import PropTypes from "prop-types"

const ResultLoading = props => {
  const { skuLists } = props
  return (
    <div className="container match-container">
      <div className="d-flex flex-wrap result-items1 justify-content-start other-match first-match result-container loading-section card-gap ">
        {skuLists.map((_, index) => (
          <div
            className="kohler-product-card-root other-match-container d-flex  justify-content-center align-items-center"
            key={index}
          >
            <div
              className={`kohler-product-card-root d-flex load-widgets flex-column justify-content-start`}
            >
              <div
                className={`shimmer-loading__image shimmer thumb-size image-part`}
              ></div>
              <div className={`d-flex flex-column justify-content-start mt-10`}>
                <div className="width-full">
                  <p className="shimmer-loading__para shimmer  loading-part"></p>
                  <p className="shimmer-loading__para shimmer  loading-part"></p>
                  <p className="shimmer-loading__para shimmer  loading-part"></p>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
ResultLoading.propTypes = {
  skuLists: PropTypes.array.isRequired,
}

export default ResultLoading
